import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { toast } from "@/hooks/use-toast";
import { LifeBuoy } from "lucide-react";

export default function EmergencyContactSection({ instructor }: { instructor: any }) {
  const [row, setRow] = useState<any>(null);
  const [draft, setDraft] = useState<any>({
    name: instructor.emergency_contact_name ?? "",
    relationship: "",
    phone: instructor.emergency_contact_phone ?? "",
    email: "",
    medical_notes: "",
  });
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    (async () => {
      const { data } = await (supabase.from as any)("instructor_emergency_contacts")
        .select("*").eq("instructor_id", instructor.id).maybeSingle();
      if (data) { setRow(data); setDraft(data); }
    })();
  }, [instructor.id]);

  const save = async () => {
    setSaving(true);
    const payload = { ...draft, instructor_id: instructor.id };
    const q = row?.id
      ? (supabase.from as any)("instructor_emergency_contacts").update(payload).eq("id", row.id)
      : (supabase.from as any)("instructor_emergency_contacts").insert(payload).select("*").single();
    const { data, error } = await q;
    setSaving(false);
    if (error) { toast({ title: "Save failed", description: error.message, variant: "destructive" }); return; }
    if (data) setRow(data);
    toast({ title: "Emergency contact saved" });
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2"><LifeBuoy className="h-4 w-4" /> Emergency Contact</CardTitle>
        <CardDescription>Kept private; used only for emergencies.</CardDescription>
      </CardHeader>
      <CardContent className="grid grid-cols-1 md:grid-cols-2 gap-3 text-sm">
        <div><Label className="text-xs">Name</Label><Input value={draft.name ?? ""} onChange={(e) => setDraft({ ...draft, name: e.target.value })} /></div>
        <div><Label className="text-xs">Relationship</Label><Input value={draft.relationship ?? ""} onChange={(e) => setDraft({ ...draft, relationship: e.target.value })} /></div>
        <div><Label className="text-xs">Phone</Label><Input value={draft.phone ?? ""} onChange={(e) => setDraft({ ...draft, phone: e.target.value })} /></div>
        <div><Label className="text-xs">Email</Label><Input value={draft.email ?? ""} onChange={(e) => setDraft({ ...draft, email: e.target.value })} /></div>
        <div className="md:col-span-2"><Label className="text-xs">Medical notes (optional)</Label><Textarea rows={2} value={draft.medical_notes ?? ""} onChange={(e) => setDraft({ ...draft, medical_notes: e.target.value })} /></div>
        <div className="md:col-span-2 flex justify-end">
          <Button size="sm" onClick={save} disabled={saving}>Save</Button>
        </div>
      </CardContent>
    </Card>
  );
}
